import TableComponent from "../../components/organism/Table/TableComponent";
import { FC, useMemo } from "react";
import { Center } from "@chakra-ui/react";
import { EditIcon } from "@chakra-ui/icons";
import { CellProps, Column } from "react-table";
import { useNavigate } from "react-router-dom";
import { primaryColor } from "../../utils/colors";
import { AuthUser } from "../../types/User/AuthUser";

interface TableRolesProps {
  dataTable: any[];
  isLoaded: boolean;
  user: AuthUser;
}

const TableRoles: FC<TableRolesProps> = ({ dataTable, isLoaded, user }) => {
  const navigate = useNavigate();

  const columns = useMemo(() => {
    const baseColumns: Column[] = [
      { Header: "Nome", accessor: "name" },
      { Header: "Tipo de perfil", accessor: "level.name" },
    ];

    if (user?.permissions && user.permissions.includes("EditRole")) {
      baseColumns.push({
        Header: "Gerir",
        accessor: "edit",
        disableSortBy: true,
        Cell: ({ row }: CellProps<any, string>) => (
          <Center justifyContent="flex-end">
            <EditIcon
              color={primaryColor}
              boxSize={6}
              mr="10px"
              cursor="pointer"
              onClick={() => {
                navigate(`/perfis/${row.original.id}`, {
                  state: { role: row.original },
                });
              }}
            />
          </Center>
        ),
      });
    }

    return baseColumns;
  }, [user.permissions, navigate]);

  return (
    <TableComponent
      isLoaded={isLoaded}
      columns={columns}
      data={dataTable}
      fixedColumnIds={[{ value: "edit", hasShadow: true }]}
    />
  );
};

export default TableRoles;
